module.exports = [{
      plugin: require('../.yarn/unplugged/gatsby-virtual-6ca983957d/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
